import { axiosInstance } from '.'
import {
  ADMIN_TRADING_ACCOUNTS_V1,
  ADMIN_TRADING_ORDERS_V1,
  ADMIN_TRADING_RECONCILIATION_V1,
  ADMIN_TRADING_SETTLEMENTS_V1,
  ADMIN_TRADING_FUNDING_CONFIG_V1,
  ADMIN_TRADING_JOURNAL_RECONCILIATION_V1,
  ADMIN_TRADING_JOURNALS_ATTENTION_V1,
  ADMIN_TRADING_JOURNAL_ACTION_V1,
} from './endpoints'

export const tradingAdminServices = {
  listAccounts: async () => {
    try {
      const data = await axiosInstance.get(ADMIN_TRADING_ACCOUNTS_V1)
      return { data: data.data, status: data.status }
    } catch (error: any) {
      return error.response
    }
  },
  listOrders: async () => {
    try {
      const data = await axiosInstance.get(ADMIN_TRADING_ORDERS_V1)
      return { data: data.data, status: data.status }
    } catch (error: any) {
      return error.response
    }
  },
  getReconciliation: async (systemDate?: string) => {
    try {
      const data = await axiosInstance.get(ADMIN_TRADING_RECONCILIATION_V1, {
        params: systemDate ? { systemDate } : {},
      })
      return { data: data.data, status: data.status }
    } catch (error: any) {
      return error.response
    }
  },
  listSettlements: async (systemDate?: string) => {
    try {
      const data = await axiosInstance.get(ADMIN_TRADING_SETTLEMENTS_V1, {
        params: systemDate ? { systemDate } : {},
      })
      return { data: data.data, status: data.status }
    } catch (error: any) {
      return error.response
    }
  },
  createSettlement: async (payload: {
    systemDate: string
    transmitterInfo: Record<string, string>
    additionalInfo?: string
  }) => {
    try {
      const data = await axiosInstance.post(ADMIN_TRADING_SETTLEMENTS_V1, payload)
      return { data: data.data, status: data.status }
    } catch (error: any) {
      return error.response
    }
  },
  getFundingConfig: async () => {
    try {
      const data = await axiosInstance.get(ADMIN_TRADING_FUNDING_CONFIG_V1)
      return { data: data.data, status: data.status }
    } catch (error: any) {
      return error.response
    }
  },
  getJournalReconciliation: async (systemDate?: string) => {
    try {
      const data = await axiosInstance.get(ADMIN_TRADING_JOURNAL_RECONCILIATION_V1, {
        params: systemDate ? { systemDate } : {},
      })
      return { data: data.data, status: data.status }
    } catch (error: any) {
      return error.response
    }
  },
  listTransfersNeedingAttention: async () => {
    try {
      const data = await axiosInstance.get(ADMIN_TRADING_JOURNALS_ATTENTION_V1)
      return { data: data.data, status: data.status }
    } catch (error: any) {
      return error.response
    }
  },
  transferAction: async (journalId: number, action: 'refresh' | 'cancel' | 'resolve') => {
    try {
      const data = await axiosInstance.post(ADMIN_TRADING_JOURNAL_ACTION_V1(journalId, action))
      return { data: data.data, status: data.status }
    } catch (error: any) {
      return error.response
    }
  },
}
